import { camelCase } from 'lodash-es';
import { AccessLevel, AccessLevels } from './app-state-types';

const subMenuKeys = ['systemForm', 'managementReports', 'extra'];

export type RawSecurityMap = Record<string, { level?: AccessLevel & Record<string, { level: AccessLevel }> }>;

export const buildFlattenedSecurityMap = (map: RawSecurityMap | undefined): Record<string, AccessLevel> => {
	if (!map) {
		// Nothing to process
		return {};
	}

	const flattened = {} as Record<string, AccessLevel>;

	// Convert admin screens with an L prefix (originally meaning "lookup") into their canonical form.
	// Capitalised names are camel-cased, e.g. LAccessCode -> accessCode
	const normaliseKey = (key: string) => {
		key = key.replace(/^l([A-Z].*)/, '$1');
		key = camelCase(key);

		// Special case for old client Day by Day sub menus - skip over these so there's only a 2 level hierarchy,
		// matching the securityPaths mappings in security-mappings.ts
		if (subMenuKeys.includes(key)) {
			return '';
		}
		return key;
	};

	const recurseMap = (map: RawSecurityMap, prefix: string) => {
		Object.keys(map).forEach((key) => {
			// Ignore the level key, as it's a property of the object, setting its access level.
			if (key === 'level') {
				return;
			}

			const entry = map[key];
			const accessLevel: AccessLevel = entry.level ?? AccessLevels.Full;

			const normalised = normaliseKey(key);
			const path = prefix && normalised ? `${prefix}.${normalised}` : normalised;
			if (path && entry.level) {
				// Only set the accessLevel if a level was specified.
				flattened[path] = accessLevel;
			}

			if (typeof entry === 'object') {
				const asMap = entry as RawSecurityMap;
				recurseMap(asMap, path || prefix);
			}
		});
	};

	recurseMap(map, '');
	return flattened;
};
